import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { getTranslation } from 'common/react/utils/translations';

export const FixturesDateHeader = ({ dateKey }) => {
    const selectedTimeZone = useSelector((state) => state.selectedRegion);
    const label =
        dateKey === 'TBCPC'
            ? getTranslation('label.fixtures.tbc-postponed-cancelled')
            : moment(dateKey, 'YYYYMMDD')
                  .tz(selectedTimeZone.timezone)
                  .format('dddd MMMM D');

    return <h2 className="fixtures__date-header">{label}</h2>;
};

FixturesDateHeader.propTypes = {
    dateKey: PropTypes.string.isRequired
};
